<template>
    <div class="gallery">

        <CoolLightBox
                :items="photos"
                :index="index"
                @close="index = null">
        </CoolLightBox>
    </div>
</template>

<script>
    import CoolLightBox from 'vue-cool-lightbox'
    import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
    export default {
        name: 'ThreedComponent',
        data() {
            return {
                photos: [],
                index: null
            };
        },
        mounted() {
            this.importAll(require.context('@/assets/_3d_',
                true,
                /^.*\.jpg$/));
        },
        methods: {
            importAll(r) {
                r.keys().forEach(key => (this.photos.push(  r(key) )));
            },
        },
        components: {
            CoolLightBox,
        },
    };
</script>

